// @flow

import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../store/Calculation';

import OptionManager from '../common/OptionManager';
import DependencyManager from '../common/DependencyManager';
import ValidationManager from "../common/ValidationManager";
import DefaultValueManager from "../common/DefaultValueManager";

import CalculationProjectInput from "./CalculationProjectInput";
import ReactAI from 'react-appinsights';

type Props = {
    calcErrorCode: number,
    calcErrorString: string,
    isLoading: boolean
}

class CalculationWrapper extends React.Component<Props> {

    optionManager: OptionManager;
    defaultValueManager: DefaultValueManager;
    dependencyManager: DependencyManager;
    validationManager: ValidationManager;

    constructor(props) {
        super(props);

        this.optionManager = new OptionManager();
        this.defaultValueManager = new DefaultValueManager(this.optionManager);
        this.dependencyManager = new DependencyManager(this.optionManager, this.defaultValueManager);
        this.validationManager = new ValidationManager(this.optionManager, this.dependencyManager);

    }

    componentDidMount() {
    }

    render() {
        return (<div>

            <CalculationProjectInput                                optionManager={this.optionManager}
                                                                    dependencyManager={this.dependencyManager}
                                                                    validationManager={this.validationManager}
                                                                    defaultValueManager={this.defaultValueManager} 
                                                                    
                                                                    isLoading={this.props.isLoading}
                                                                    
                                                                    calcErrorCode={this.props.calcErrorCode}
                                                                    calcErrorString={this.props.calcErrorString}
            
            />

        </div>);
    }
    
}

export default ReactAI.withTracking(connect(
    state => state.calculation,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(CalculationWrapper));



// WEBPACK FOOTER //
// ./src/components/CalculationWrapper.js